/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './more-menu.css';
import { ALL_ROUTES, MORE_MENU_SCREEN } from '../../global/Constants';
import { withRouter } from 'react-router-dom';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import moment from 'moment';
import DataProvider from '../../providers/DataProvider';

class NotificationPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            allNotificationData: [],
            unreadCount: 0
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const data = this.props.location.state;
            if (data?.activeTab === 2 || data?.selectedTab === 2) {
                this.getUserNotification();
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getUserNotification() {
        if (Utilities.isNetworkConnected()) {
            this.props.loaderCallback(true);

            try {
                ApiServices.getUserNotification().then(response => {
                    var status = response.success;
                    if (status) {
                        const newArrayOfObj = response.data.notifications;
                        this.setState({ allNotificationData: newArrayOfObj, unreadCount: response.data.unread });
                        this.props.loaderCallback(false);
                        this.props.setNotificationCount(response.data.unread);
                        DataProvider.getInstance().setNotificationCount(response.data.unread);

                    } else {
                        this.props.loaderCallback(false);
                        Utilities.LogPrint("getUserNotification", response);
                    }
                }).catch(error => {
                    this.props.loaderCallback(false);
                });
            } catch (error) {
                this.props.loaderCallback(false);
            }
        }
    }


    _handleActivityDetails = (e, id) => {
        e.preventDefault(e);
        this.props.loaderCallback(true);
        var body = JSON.stringify({
            notification_id: [id],
        });
        try {
            ApiServices.updateUserNotification(body).then(response => {
                var status = response.success;
                if (status) {
                    this.props.history.push(ALL_ROUTES.ACTIVITY_DETAILS_ROUTE);
                    Utilities.LogPrint("updateUserNotification", this.state);
                } else {
                    this.props.loaderCallback(false);
                    Utilities.LogPrint("updateUserNotification", response);
                }
            }).catch(error => {
                this.props.loaderCallback(false);
                Utilities.LogPrint("updateUserNotification", error);
            });
        } catch (error) {
            this.props.loaderCallback(false);
            Utilities.LogPrint("updateUserNotification", error);
        }
    }

    render() {
        const { isActive } = this.props;
        const { allNotificationData, unreadCount } = this.state;
        const allNotificationDataListItem = allNotificationData.map((notification, i) =>
            <li key={i} onClick={(e) => this._handleActivityDetails(e, notification.notification_id)}>
                <div>
                    <span className="date-time">{moment(notification.created_at).format("dddd, Do MMMM, YYYY | h:mm a")}</span> <span className={(notification.is_read === 1) ? "d-none" : "ml-2 notification-dot"}></span>
                    <p>{notification.message}</p>
                </div>
                <i className="customic ic-go-button"></i>
            </li>
        );
        return (
            <div id="notifications" className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <div className="row">
                    <div className="col-12">
                        <h5 className="mb-4">
                            <a className="more-menu-back" onClick={() => { this.props._sendToParent(false) }}>
                                <i className="customic ic-back-button"></i>
                            </a> {MORE_MENU_SCREEN.NOTIFICATIONS} {(unreadCount === 0) ? "" : `(${unreadCount})`}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <ul className="notification-list">
                            {allNotificationDataListItem}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(NotificationPage)